import { formatStatus } from './utils';

import {
  IGradeReviewRequestListResponseData,
  IGradeReviewRequestListResponseRawData,
} from '../../types';

/**
 * Formatter to transform the `raw grade review request list API response` to the format that
 */
export function formatGradeReviewRequestListResponse(
  response: IGradeReviewRequestListResponseRawData
): IGradeReviewRequestListResponseData {
  const {
    gradeReviewRequestList,
    totalCount: count,
    status: rawStatusFilterOptions,
  } = response;
  const gradeList = gradeReviewRequestList.map((gradeReviewRequest) => {
    const {
      _id: gradeReviewRequestId,
      appraisalCode,
      assetName,
      createdAt,
      creditAmount: revisedPrice,
      dealPrice: purchasePrice,
      dealPaymentType,
      isAutomatedAssessment,
      isCreatedByNL,
      status: gradeStatus,
      ticketNumber: gradeReviewTicketNumber,
    } = gradeReviewRequest;

    const displayStatus = [dealPaymentType];
    const formattedGradeStatus = formatStatus(gradeStatus);

    return {
      appraisalCode,
      assetName,
      revisedPrice,
      displayStatus,
      gradeReviewRequestId,
      date: createdAt,
      gradeReviewTicketNumber,
      gradeStatus,
      gradeStatusName: formattedGradeStatus,
      isAutomatedAssessment,
      isCreatedByNL,
      purchasePrice,
    };
  });

  const gradeFilterOptions = rawStatusFilterOptions.map((filter) => {
    const { count: filterCount, key, label, value } = filter;

    return {
      label: {
        en: value.en,
        ar: value.ar || value.en,
      },
      value: key,
      count: filterCount,
      subtitle: {
        isCritical: label.critical,
        value: {
          en: label.value.en,
          ar: label.value.ar || label.value.en,
        },
      },
    };
  });

  return {
    gradeList,
    count,
    gradeFilterOptions,
  };
}
